import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { UNIFIED_ASSET_MANAGEMENT } from '@dtx-company/true-common/src/constants/featureFlags'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

export function useAssetsOrCodesPathname(): Routes.ASSETS | Routes.CODES {
  const [isUnifiedAssetManagementEnabled] = useFlowFeature(UNIFIED_ASSET_MANAGEMENT, {
    autoUpdate: true
  })
  if (isUnifiedAssetManagementEnabled) {
    return Routes.ASSETS
  }
  return Routes.CODES
}
